import api from '../api/client'

const leiloesService = {
  // Listar leilões por organizador
  getByOrganizador: async (organizadorId, filters = {}) => {
    const params = new URLSearchParams()
    
    if (filters.tipo_leilao) {
      params.append('tipo_leilao', filters.tipo_leilao)
    }
    // Por padrão só leilões ativos (seletores das telas); `todos: true` traz os inativos também
    if (filters.status) {
      params.append('status', filters.status)
    } else if (!filters.todos) {
      params.append('status', 'on')
    }

    const response = await api.get(`/organizadores/${organizadorId}/leiloes?${params}`)
    return response.data
  },

  // Criar leilão
  create: async (organizadorId, leilaoData, bannerFile = null) => {
    // Primeiro criar o leilão
    const response = await api.post(`/organizadores/${organizadorId}/leiloes`, leilaoData)
    const leilao = response.data
    
    // Se tem banner, fazer upload
    if (bannerFile) {
      try {
        const uploadResponse = await leiloesService.uploadBanner(organizadorId, leilao.id, bannerFile)
        leilao.banner_url = uploadResponse.banner_url
      } catch (error) {
        console.error('Erro ao fazer upload do banner:', error)
        // Não falhar a criação por causa do banner
      }
    }
    
    return leilao
  },

  // Buscar leilão por ID
  getById: async (organizadorId, leilaoId) => {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}`)
    return response.data
  },

  // Obter leilão (alias para getById)
  obterLeilao: async (organizadorId, leilaoId) => {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}`)
    return response.data
  },

  // Atualizar leilão
  update: async (organizadorId, leilaoId, leilaoData) => {
    const response = await api.put(`/organizadores/${organizadorId}/leiloes/${leilaoId}`, leilaoData)
    return response.data
  },

  // Excluir leilão
  delete: async (organizadorId, leilaoId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/leiloes/${leilaoId}`)
    return response.data
  },

  // Buscar tipos disponíveis
  getTiposDisponiveis: async (organizadorId) => {
    const response = await api.get(`/organizadores/${organizadorId}/tipos-disponiveis`)
    return response.data
  },

  // Upload de banner
  uploadBanner: async (organizadorId, leilaoId, file) => {
    const formData = new FormData()
    formData.append('file', file)
    
    const response = await api.post(
      `/organizadores/${organizadorId}/leiloes/${leilaoId}/upload-banner`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }
}

export default leiloesService